import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { EmptyFolderIcon } from '@systemeio/ui'

const NotificationEmptyList = () => {
  const { t } = useLocoTranslation()

  return (
    <div className="bg-background-secondary flex w-full flex-col items-center justify-center gap-3 rounded-b-lg py-20">
      <EmptyFolderIcon height={100} width={100} />
      <div className={`flex flex-col items-center`}>
        <span className={'text-text-primary text-base font-medium'}>
          {t('dashboard.notifications.empty_list.title')}
        </span>
        <span className={'text-text-primary text-base'}>
          {t('dashboard.notifications.empty_list.description')}
        </span>
      </div>
    </div>
  )
}

export default NotificationEmptyList
